// Libraries
var React = require('react');
var chunk = require('lodash/chunk');
var $ = require('jquery');

// Components
var LoadMore = require('LoadMore/LoadMore');
var ArticleLink = require('../ArticleLink/ArticleLinkModule');

// Assets
var spinner = require('images/Rolling.svg');

// Styles
require('./TrendingVideoGridModule.scss');

class TrendingVideoGridModule extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			modules: chunk(this.props.data.modules, this.props.data.itemsPerGrid),
			fullSet: this.props.data.modules,
			isLoading: false,
			loadMoreLink: this.props.data.loadMoreLink,
			initialPageNumber: this.props.data.initialPageNumber || 0,
		};
		this.loadMoreIndex = this.props.data.initialPageNumber || 0;
		this.allModules = global.Components;
		this.moduleId = this.props.data.id;
		this.placementName = this.props.data.placementName;
	};

	componentDidMount() {
		if (this.props.data.loadMoreOnScroll) {
			window.addEventListener('scroll', this.scrollHandler);
		}

		if (window.sessionStorage && this.moduleId) {
			const storedData = window.sessionStorage.getItem(this.moduleId);
			if (storedData) {
				this.handleData(JSON.parse(storedData));
			}

			window.addEventListener('beforeunload', () => {
				if (!this.trendingGrid.contains(document.activeElement) && (document.activeElement.tagName === 'A' && document.activeElement.href !== window.location.href)) {
					window.sessionStorage.removeItem(this.moduleId);
				}
			});
		}
	}

	scrollHandler = e => {
		const rect = this.trendingGrid.getBoundingClientRect();

		if (window.innerHeight > rect.bottom && !this.state.isLoading) {
			this.setState({
				isLoading: true,
			}, () => {
				this.handleLoadMore(e);
			});
		}
	};

	handleData = data => {
		let fullSet = this.state.fullSet.slice();
		let newSet = fullSet.concat(data.modules);
		this.setState({
			modules: chunk(newSet, this.props.data.itemsPerGrid),
			fullSet: newSet,
			isLoading: false,
			loadMoreLink: data.loadMoreLink
		}, () => {
			if (window.LazyLoad) {
				window.LazyLoad.concat();
			}

			if (window.AppUrlModifier) {
				window.AppUrlModifier.append();
			};
		});
	};

	handleLoadMore = e => {
		this.setState({ isLoading: true });

		if (this.state.loadMoreLink) {
			$.ajax({
				method: "GET",
				url: this.state.loadMoreLink.url,
			})
				.done(data => {
					if (e) {
						this.loadMoreIndex += 1;

						if (window.sessionStorage && this.moduleId) {
							const prevData = JSON.parse(window.sessionStorage.getItem(this.moduleId));
							window.sessionStorage.setItem(this.moduleId, prevData
								? JSON.stringify(Object.assign({}, prevData, {
									modules: prevData.modules.concat(data.modules),
									loadMoreLink: (data.loadMoreLink 
                                        ? 
                                            Object.assign({}, prevData.loadMoreLink, {
										        url: data.loadMoreLink.url,
									        })
                                        : null),
								}))
								: JSON.stringify(data));
						}
					}

					this.handleData(data);
				})
				.fail(() => {
					this.setState({ isLoading: false });
				});
		} else {
			this.setState({ isLoading: false });
			window.removeEventListener('scroll', this.scrollHandler);
		}
	};

	render() {
		return (
			<div className="TrendingVideoGrid" id={this.moduleId} data-placement-name={this.placementName} ref={trending => this.trendingGrid = trending}>
				{this.state.modules.map((modules, index) => {
					return (<div className="TrendingVideoGrid__container" key={index}>
						{modules.length > 0 &&
							<div className="TrendingVideoGrid__16-9--left">
								<div className="TrendingVideoGrid__16-9__ratio">
									<div className="TrendingVideoGrid__16-9__container">
										{modules[0] &&
												<ArticleLink data={modules[0].data} isTrendingVideo={this.props.isTrendingVideo} />
												// React.createElement(this.allModules[modules[0].name], { "key": 0, "data": modules[0].data })
										}
									</div>
								</div>
							</div>
						}
						{modules.length > 1 &&
								<div className="TrendingVideoGrid__16-9--right">
									<div className="TrendingVideoGrid__16-9__ratio">
										<div className="TrendingVideoGrid__16-9__container">
											{modules[1] &&
													<ArticleLink data={modules[1].data} isTrendingVideo={this.props.isTrendingVideo} />
													// React.createElement(this.allModules[modules[1].name], { "key": 1, "data": modules[1].data })
											}
										</div>
									</div>
								</div>
						}
						{modules.length > 2 &&
								<div className="TrendingVideoGrid__20-9">
									<div className="TrendingVideoGrid__20-9__ratio">
										<div className="TrendingVideoGrid__20-9__container">
											{modules[2] &&
													<ArticleLink data={modules[2].data} isTrendingVideo={this.props.isTrendingVideo} />
													// React.createElement(this.allModules[modules[2].name], { "key": 2, "data": modules[2].data })
											}
										</div>
									</div>
								</div>
						}
					</div>);
				})}

				{!this.state.isLoading && this.state.loadMoreLink &&
						<LoadMore handle={this.handleLoadMore} caption="Show more" isTrending={true} context="trending videos"/>
				}

				{this.state.isLoading &&
						<img src={spinner} className="spinner" alt="Loading animation" />
				}
			</div>
		)
	}
}

module.exports = TrendingVideoGridModule;



// WEBPACK FOOTER //
// ./src/components/TrendingVideoGrid/TrendingVideoGridModule.js